

export default function Chat() { return <iframe title='Chat Instituçional Publico' src="https://cip.vamsolucoes.com/674d820b4c72eeb7c0b4109a/token" width={'100%'} height={'94%'} style={{ border: 'none' }} /> }
